<div class="dash-card no-padding">
    <div class="dash-card-header d-block" style="flex-direction: column;">
        <div class="row no-gutters">
            <div class="col-12">
                <div style="padding-bottom: 0;">
                    <h2>Departamentos</h2>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                *ngIf="loading || data.length > 0 || hasFilters">
                <div class="d-flex align-items-center">
                    <button type="button" class="sort-button mr-2"
                        (click)="refreshData()" [disabled]="loading">
                        <svg-icon src="assets/images/icon-renew.svg"></svg-icon>
                        <span>Atualizar</span>
                    </button>
                </div>

                <div class="d-flex align-items-center">
                    <app-button
                        *ngIf="!isCompanyRoute && hasFilters && permissionObj.canFilter && !loading"
                        [danger]="true" [outline]="true" class="add-button mr-2"
                        (onClick)="resetForm()">
                        <svg-icon src="assets/images/icon-times.svg"
                            class="filter-clear-icon"></svg-icon>
                        Limpar filtros
                    </app-button>

                    <app-button [inverted]="true" class="add-button mr-2"
                        (onClick)="toggleFilterModal()" [disabled]="loading"
                        *ngIf="!isCompanyRoute && permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                        <svg-icon src="assets/images/icon_filter.svg"
                            class="mr-2"></svg-icon>
                        {{ hasFilters ? 'Editar filtros' : 'Filtrar listagem' }}
                    </app-button>

                    <app-button (onClick)="newDepartment = true"
                        class="add-button"
                        *ngIf="!isCompanyRoute && permissionObj.canAdd && (loading || data.length > 0 || hasFilters)">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2 mb-1"></svg-icon>
                        Adicionar departamento
                    </app-button>
                </div>
            </div>

            <div class="col-12 mt-3 px-0"
                *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>
        </div>
    </div>

    <div class="dash-card-body padding-container" style="margin-top: 32px;">
        <ng-container *ngIf="loading">
            <table #table class="bordered">
                <tbody>
                    <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                        <td>
                            <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '150px',
                                        marginBottom:'0'
                                          }">
                            </ngx-skeleton-loader>
                        </td>
                        <td *ngIf="!isCompanyRoute">
                            <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                            </ngx-skeleton-loader>
                        </td>
                        <td *ngIf="!isCompanyRoute">
                            <div
                                style="display: flex; flex-direction: column; gap: 8px;">
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '120px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                                <ngx-skeleton-loader [theme]="{
                                    height: '14px',
                                    width: '100px',
                                    marginBottom:'0'
                                  }">
                                </ngx-skeleton-loader>
                            </div>
                        </td>
                        <td>
                            <ngx-skeleton-loader [theme]="{
                                height: '24px',
                                width: '70px',
                                marginBottom:'0'
                              }">
                            </ngx-skeleton-loader>
                        </td>
                        <td *ngIf="!isCompanyRoute">
                            <div
                                style="display: flex; gap: 8px; justify-content: flex-end;">
                                <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '16px',
                                    marginBottom:'0',
                                    borderRadius: '0'
                                  }">
                                </ngx-skeleton-loader>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <table class="bordered" *ngIf="!loading && data.length > 0">
            <thead>
                <tr>
                    <th>{{isCompanyRoute ? 'Nome' : 'Departamento'}}</th>
                    <th *ngIf="!isCompanyRoute">Perfis de acessos</th>
                    <th *ngIf="!isCompanyRoute">Atualizado em</th>
                    <th>Status</th>
                    <th *ngIf="!isCompanyRoute"></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let item of data; trackBy: trackByItemId">
                    <td>
                        {{item.department}}
                    </td>

                    <td *ngIf="!isCompanyRoute">
                        {{renderUsersType(item.users_type)}}
                    </td>

                    <td *ngIf="!isCompanyRoute">
                        <div class="dash-card-item-content">
                            <div class="dash-card-item-content-title">
                                {{displayDateTime(item.updated_at).date}}
                            </div>
                            <div class="dash-card-item-content-subtitle">
                                {{displayDateTime(item.updated_at).time}}
                            </div>
                        </div>
                    </td>

                    <td>
                        <div class="status-tag"
                            [class.-inactive]="item.status === 'inactive'">
                            {{getStatusDisplay(item.status)}}</div>
                    </td>

                    <td *ngIf="!isCompanyRoute">
                        <div class="table-options">
                            <app-tooltip text="Editar" position="top"
                                *ngIf="permissionObj.canChange">
                                <button class="dash-item-button"
                                    (click)="handleEdit(item.id)">
                                    <svg-icon
                                        src="assets/images/icon-edit.svg"></svg-icon>
                                </button>
                            </app-tooltip>
                        </div>
                    </td>
                </tr>
            </tbody>
            <app-spacer [bottom]="28"></app-spacer>
        </table>

        <!-- Empty state - sem filtros -->
        <ng-container *ngIf="!loading && data.length === 0 && !hasFilters">
            <app-empty-content [isVisible]="true" [large]="true"
                title="Não há nenhum departamento para exibir"
                description="Não há departamentos para serem exibidos no momento"
                icon="/assets/images/figure_3d_search.png"
                [buttonLabel]="isCompanyRoute ? undefined : 'Adicionar departamento'"
                (onClick)="newDepartment = true">
            </app-empty-content>
        </ng-container>

        <!-- Empty state - com filtros -->
        <ng-container *ngIf="!loading && data.length === 0 && hasFilters">
            <app-empty-content [isVisible]="true" [large]="true"
                title="Não encontramos resultados para sua busca"
                description="Não há registros para o termo digitado, verifique a ortografia ou tente novamente com outras palavras"
                icon="/assets/images/figure_3d_search.png">
            </app-empty-content>
        </ng-container>
    </div>
</div>



<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [dashPagination]="true">
        </app-pagination>
    </div>
</div>



<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="department"
                placeholder="Digite" label="Departamento">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="profileOptions" [group]="filterForm"
                controlName="profiles" placeholder="Selecione" [multiple]="true"
                label="Perfis de acessos">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>


<app-side-modal [active]="newDepartment"
    [title]="editingId ? 'Editar departamento' : 'Adicionar departamento'"
    (onClose)="handleClose()">
    <form [formGroup]="departmentForm">
        <div class="row">
            <div class="col-12">
                <app-input [group]="departmentForm" controlName="department"
                    placeholder="Digite" label="Nome">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="profileOptions" [group]="departmentForm"
                    controlName="roles" placeholder="Selecione"
                    [multiple]="true" label="Perfis de acesso">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>

        <app-spacer [bottom]="32"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="handleCancelDepartment()"
                    class="add-button" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="handleAddDepartment()"
                        [loading]="addingDepartment"
                        [disabled]="addingDepartment || loading || departmentForm.invalid">
                        {{editingId ? 'Salvar departamento' : 'Adicionar
                        departamento' }}
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>